import { Link } from "react-router-dom";

export default function MarketingFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="py-12 text-sm text-stone-500 bg-white border-t border-stone-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2 md:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="w-10 h-10 rounded-full grid place-items-center shadow-md" style={{ background: "#1E1B4B" }}>
              <span className="devanagari text-amber-400 text-xl leading-none">अ</span>
            </span>
            <span className="font-serif-display text-2xl font-bold text-[#1E1B4B] leading-none">
              Anubandh<span className="text-amber-600 mx-0.5">·</span>AI
            </span>
          </div>
          <p className="mt-4 max-w-sm">India&apos;s Marriage Intelligence Platform. Where destiny meets clarity.</p>
        </div>
        <div>
          <div className="overline mb-3">Explore</div>
          <ul className="space-y-2">
            <li><Link className="underline-grow" to="/how-it-works" data-testid="footer-how">How it works</Link></li>
            <li><Link className="underline-grow" to="/kundali" data-testid="footer-kundali">Kundali × AI</Link></li>
            <li><Link className="underline-grow" to="/family" data-testid="footer-family">Family Circle</Link></li>
            <li><Link className="underline-grow" to="/philosophy" data-testid="footer-philosophy">Philosophy</Link></li>
            <li><Link className="underline-grow" to="/moments" data-testid="footer-moments">Real Moments</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-3">Product</div>
          <ul className="space-y-2">
            <li><Link className="underline-grow" to="/compare" data-testid="footer-compare">Compare</Link></li>
            <li><Link className="underline-grow" to="/subscription" data-testid="footer-pricing">Pricing</Link></li>
            <li><Link className="underline-grow" to="/contact" data-testid="footer-contact">Contact us</Link></li>
            <li><a className="underline-grow" href="mailto:hello@anubandh.ai">hello@anubandh.ai</a></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-3">Legal</div>
          <ul className="space-y-2">
            <li><Link className="underline-grow" to="/terms" data-testid="footer-terms">Terms &amp; Conditions</Link></li>
            <li><Link className="underline-grow" to="/privacy" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link className="underline-grow" to="/refund" data-testid="footer-refund">Refund Policy</Link></li>
            <li><Link className="underline-grow" to="/shipping" data-testid="footer-shipping">Shipping &amp; Delivery</Link></li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-10 pt-6 border-t border-stone-200 text-xs flex flex-col md:flex-row gap-2 justify-between">
        <div>© {year} Anubandh.ai · A messenger of the written bond</div>
        <div className="devanagari text-amber-700">यत्र नार्यस्तु पूज्यन्ते, रमन्ते तत्र देवताः</div>
      </div>
    </footer>
  );
}
